var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-button", {
    staticStyle: {
      height: "80px",
      width: "250px"
    },
    attrs: {
      type: "primary",
      plain: ""
    },
    on: {
      click: function click($event) {
        return _vm.addNoticeBtn();
      }
    }
  }, [_vm._v(" 添加游戏公告 ")]), _c("div", [_vm.noticeDialog ? _c("el-dialog", {
    attrs: {
      title: _vm.addOrEdit == 1 ? "添加游戏公告" : "编辑游戏公告",
      visible: _vm.noticeDialog,
      center: ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.noticeDialog = $event;
      }
    }
  }, [_c("add-notice-msg", {
    ref: "perChild",
    staticStyle: {
      height: "600px",
      "overflow-y": "auto"
    },
    attrs: {
      msg: _vm.info,
      addOrEdit: _vm.addOrEdit
    },
    on: {
      backNotice: _vm.backNotice,
      onCancel: function onCancel($event) {
        _vm.noticeDialog = false;
      }
    }
  })], 1) : _vm._e()], 1), _c("div", {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    staticStyle: {
      "margin-right": "50px"
    },
    attrs: {
      label: "时效状态："
    }
  }, [_c("el-checkbox-group", {
    model: {
      value: _vm.searchInfo.status,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "status", $$v);
      },
      expression: "searchInfo.status"
    }
  }, [_c("el-checkbox", {
    attrs: {
      label: 1
    }
  }, [_vm._v("生效中")]), _c("el-checkbox", {
    attrs: {
      label: 2
    }
  }, [_vm._v("未生效")]), _c("el-checkbox", {
    attrs: {
      label: 3
    }
  }, [_vm._v("已过期")])], 1)], 1), _c("el-form-item", [[_c("el-button", {
    staticStyle: {
      width: "100px"
    },
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.queryEvent();
      }
    }
  }, [_vm._v("查询")])]], 2)], 1), _c("show-notice-table", {
    ref: "myChild",
    on: {
      ready: _vm.onTableReady,
      goEditBtn: _vm.goEditBtn
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };